/* eslint-disable no-await-in-loop */
/**
 * 健康习惯 V2 判定载荷（P1-1.7）
 *
 * `POST /healthHabit/v2/profile` → `UserHabitProfileResponse`
 * 契约真源：metaspace `api_reference/UserHealthHabitInsightApi/`（含五份样例载荷）。
 *
 * 为什么不缓存（同文件的 indicators/index 都有 5 分钟缓存）：
 * 缓存会把"服务端刚把引擎关掉"这件事继续显示成有数据，而这两个端点的唯一开关就是它；
 * 页面每次进入只发一次 profile，量级上也不需要缓存。
 *
 * 返回形状刻意是 `{ ok, reason, code, data }` 而不是裸 data：
 * **上游故障与"这个用户没数据"不能塌成同一个值**（P0-0.4 / P3 的全部意义）。
 * 调用方拿 `ok:false` 时按 `reason` 决定降级文案与埋点，不许自己猜。
 *
 * reason 取值与 REST 错误码的对应（写在这里是因为 1.7 的降级标签必须与它一致）：
 *   07020027 → UPSTREAM_ERROR   真故障（Dubbo 超时/无 provider）
 *   07020028 → UPSTREAM_EMPTY   上游没给结果：引擎未开 / 参数越界 / 日期不可解析
 *   其它非 00000 → UPSTREAM_ERROR（未知错误码按故障处理，别当"没数据"骗用户）
 *   网络层失败 → NETWORK_ERROR
 */
import $x from '@/utils/$x';

export const PROFILE_FAILURE_REASONS = {
  '07020027': 'UPSTREAM_ERROR',
  '07020028': 'UPSTREAM_EMPTY',
};

export async function getHealthHabitProfile(params) {
  let res;
  try {
    res = await $x.post('/healthHabit/v2/profile', params);
  } catch (error) {
    return { ok: false, reason: 'NETWORK_ERROR', code: null, data: null };
  }
  if (!res || typeof res !== 'object') {
    return { ok: false, reason: 'MALFORMED_RESPONSE', code: null, data: null };
  }
  const code = res.code === undefined ? null : String(res.code);
  if (code !== null && code !== '00000') {
    return {
      ok: false,
      code,
      reason: PROFILE_FAILURE_REASONS[code] || 'UPSTREAM_ERROR',
      data: null,
    };
  }
  const payload = res.data !== undefined ? res.data : res;
  if (!payload || typeof payload !== 'object') {
    return { ok: false, reason: 'MALFORMED_RESPONSE', code, data: null };
  }
  return { ok: true, code: '00000', reason: null, data: payload };
}
